import { Printer, RotateCcw, Ticket, FileText } from 'lucide-react'
import { QuickTickets } from '../components/QuickTickets'
import { useState, type FormEvent } from 'react'

const escHtml=(value:unknown)=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]||char))

export function Observations() {
  const [title,setTitle]=useState('')
  const [text,setText]=useState('')
  const [error,setError]=useState('')
  const [tab,setTab]=useState<'quick'|'manual'>('quick')

  function clearForm(){
    setTitle('')
    setText('')
    setError('')
  }

  function printObservation(event:FormEvent){
    event.preventDefault()
    const observation=text.trim()
    if(!observation){setError('Digite a observação antes de imprimir.');return}
    setError('')
    const now=new Date().toLocaleString('pt-BR')
    const heading=title.trim()||'OBSERVAÇÃO'
    const body=escHtml(observation).replace(/\n/g,'<br>')
    const html=`<!doctype html><html><head><meta charset="utf-8"><title>${escHtml(heading)}</title><style>@page{size:80mm auto;margin:3mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;width:74mm;margin:0 auto;color:#000;font-size:14px}h1{text-align:center;font-size:17px;margin:0 0 4px}.title{text-align:center;font-size:20px;font-weight:900;border:3px double #000;padding:8px;margin:9px 0 12px}.text{font-size:16px;line-height:1.45;white-space:normal;overflow-wrap:anywhere;padding:8px 0;border-top:2px dashed #000;border-bottom:2px dashed #000}.date{text-align:center;margin-top:12px;font-size:11px}.footer{text-align:center;margin-top:10px;font-size:10px}</style></head><body><h1>GONÇALO MUSIC BAR</h1><div class="title">${escHtml(heading)}</div><div class="text">${body}</div><div class="date">${escHtml(now)}</div><div class="footer">Impressão manual de observação</div><script>window.onload=()=>{window.print();setTimeout(()=>window.close(),850)}<\/script></body></html>`
    const win=window.open('','_blank','width=420,height=760')
    if(!win){setError('O navegador bloqueou a impressão. Libere pop-ups para este site.');return}
    win.document.open()
    win.document.write(html)
    win.document.close()
  }

  return <>
    <div className="page-heading">
      <div><span className="eyebrow dark">IMPRESSÃO RÁPIDA</span><h1>Observações</h1><p>Digite qualquer recado ou observação e imprima na térmica.</p></div>
    </div>
    <div className="quick-ticket-mode"><button type="button" className={tab==='quick'?'is-active':''} onClick={()=>setTab('quick')}><Ticket size={18}/> Fichas rápidas por mesa</button><button type="button" className={tab==='manual'?'is-active':''} onClick={()=>setTab('manual')}><FileText size={18}/> Observação manual</button></div>
    {tab==='quick'?<QuickTickets/>:<section className="panel" style={{maxWidth:760,margin:'0 auto'}}> 
      <div className="panel-heading">
        <div><span className="eyebrow dark">OBSERVAÇÃO MANUAL</span><h3>Nova observação</h3></div>
        <button type="button" className="ghost-button" onClick={clearForm}><RotateCcw size={17}/> Limpar</button>
      </div>
      <form className="entity-form" onSubmit={printObservation}>
        <label>Título opcional<input value={title} onChange={e=>setTitle(e.target.value)} placeholder="Ex.: Atenção cozinha, Recado, Mesa sem número..." autoFocus/></label>
        <label>Observação<textarea value={text} onChange={e=>setText(e.target.value)} placeholder="Digite aqui tudo o que deseja imprimir..." required style={{minHeight:220,resize:'vertical',fontSize:17,lineHeight:1.5}}/></label>
        {error&&<div className="form-error" role="alert">{error}</div>}
        <div className="settings-tip"><Printer size={18}/><span>A observação será impressa em formato térmico de 80 mm, com data e horário.</span></div>
        <div className="form-actions"><button type="button" className="ghost-button" onClick={clearForm}>Limpar</button><button className="primary-button"><Printer size={18}/> Imprimir observação</button></div>
      </form>
    </section>}
  </>
}
